import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll-reveal"
export default class extends Controller {
  static targets = ["section", "hero"];

  static values = {
    options: {
      type: Object,
      default: {
        root: null,
        rootMargin: "0px",
        threshold: 0.15,
      },
    },
  };

  connect() {
    this.observer = new IntersectionObserver(this.callback.bind(this), this.optionsValue);
    this.sectionTargets.forEach((section) => {
      // On vérifie que l'élément n'est pas déjà animé
      if (!section.classList.contains("animated")) {
        section.style.opacity = "0";
        this.observer.observe(section);
      }
    });
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  callback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.classList.contains("animated")) {
        if (this.sectionTargets.indexOf(entry.target) % 2 === 0) {
          entry.target.classList.add("animated", "animate-fade_in_up_from_right");
        } else {
          entry.target.classList.add("animated", "animate-fade_in_up_from_left");
        }
        entry.target.style.removeProperty("opacity");
        observer.unobserve(entry.target); // Désobserve l'élément
      }
    });
  }
}
